import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get('/account', { params })
}

export default {
  getAll
}